export const environment = {
  production: true,
  appDomains: ["financeiro.cinemadocentro.billytheticket.com.br"],
  apiAddr: "https://financeiro.cinemadocentro.billytheticket.com.br/api/",
  legacyRootAddr: "https://financeiro.cinemadocentro.billytheticket.com.br/legacy/",
  appTitle: "Cinema do Centro",
  system: "billyerp"
};
